<div class="md-input-container" fxLayout.xs="column">
    <div>
    <mat-form-field class="mat-form-withtooltip" fxFlex.lt-md="90">
        <mat-label>Manager</mat-label>
        <mat-select #manager="ngModel" 
        [(ngModel)]="value" name="manager" (openedChange)="onOpen($event)"
        [compareWith]="objectComparison"
        [panelClass]="isLoading || !isOpen ? 'hide-dummy-option' : ''"
        [required]="required"
        >
            <mat-option class="minh88" *ngIf="items === null || !items.length" disabled>
                <div class="select-placeholder-container">
                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                </div>
            </mat-option>
            <mat-option *ngFor="let item of items" [value]="item">{{item.Name}}</mat-option>
        </mat-select>
        <mat-error class="md-errormsg" *ngIf="!manager.valid && manager.touched && required">Required</mat-error>
    </mat-form-field>
    <mat-icon fxFlexAlign.lt-md="center" matTooltip='Please select the manager, or add a new manager by clicking "Add New Manager" below.'
              matTooltipPosition="above">
        help
    </mat-icon>
    </div>
    <mat-error class="sm-errormsg" *ngIf="!manager.valid && manager.touched && required">Required</mat-error>
</div>
